/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCropDtoFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CropDto, type ProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/Crops/{id}
 */
export interface CropsItemRequestBuilder extends BaseRequestBuilder<CropsItemRequestBuilder> {
    /**
     * Gets the crop.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CropDto>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CropDto | undefined>;
    /**
     * Gets the crop.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CropsItemRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/Crops/{id}";
/**
 * Metadata for all the requests in the request builder.
 */
export const CropsItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CropsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCropDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
